import { render, staticRenderFns } from "./ChamadoPrioridadeForm.vue?vue&type=template&id=d0ac9cfa&"
import script from "./ChamadoPrioridadeForm.vue?vue&type=script&lang=js&"
export * from "./ChamadoPrioridadeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports